import { connect } from "react-redux";
// API
import api from "api";
// Action
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  initFreeOpinionReport,
  setFreeOpinionReport,
  setErrors,
  setEditableComment,
  setComment
} from "redux/modules/freeOpinionReport";

// Component
import FreeOpinionReport from "components/ReportDetail/FreeOpinionReport";
// Utils
import history from "utils/history";
import { showSnackbar } from "redux/modules/snackbar";
import {
  openConfirmDialog,
  closeConfirmDialog
} from "redux/modules/confirmDialog";
import { openMessageDialog } from "redux/modules/messageDialog";

const mapStateToProps = state => {
  return { ...state };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),
  initFreeOpinionReport: () => {
    dispatch(initFreeOpinionReport());
  },
  fetchFreeOpinionReport: () => {
    const { id } = ownProps.match.params;
    const params = new URLSearchParams(window.location.search);
    const attrItem = params.get('attr_item_id');

    const pathNum = /\d(?=_)/.exec(ownProps.match.path);
    if (attrItem) {
      api
        .get(`free_opinion_${pathNum}_report/${id}`, { attr_item_id: attrItem })
        .then(res => {
          if ("errors" in res) {
            dispatch(setErrors(res.errors));
          }
          dispatch(setFreeOpinionReport(res));
        })
        .catch(error => dispatch(openErrorDialog(error)));
    } else {
      api
        .get(`free_opinion_${pathNum}_report/${id}`)
        .then(res => {
          if ("errors" in res) {
            dispatch(setErrors(res.errors));
          }
          dispatch(setFreeOpinionReport(res));
        })
        .catch(error => dispatch(openErrorDialog(error)));
    }
  },
  changeEditable: (id, isEdit) => {
    dispatch(setEditableComment(id, isEdit));
  },
  changeAnswer: (id, answer) => {
    dispatch(setComment(id, answer));
  },
  updateAnswer: (resultId, answer) => {
    if (answer.length <= 400) {
      const { id } = ownProps.match.params;
      const attrItemId = new URLSearchParams(window.location.search).get('attr_item_id');
      const pathNum = /\d(?=_)/.exec(ownProps.match.path);
      const newAnswer = {
        resultId,
        answer,
        attrItemId
      };
      api
        .post(`free_opinion_${pathNum}_report/${id}`, newAnswer)
        .then(res => {
          if ("errors" in res) {
            dispatch(setErrors(res.errors));
          }
          dispatch(setFreeOpinionReport(res));
          dispatch(showSnackbar("更新しました"));
        })
        .catch(error => dispatch(openErrorDialog(error)));
    } else {
      dispatch(
        openMessageDialog(
          `コメントは400字以内で入力してください。(現在${answer.length}文字)`
        )
      );
    }
  },
  deleteAnswer: (resultId) => {
    const { id } = ownProps.match.params;
    const pathNum = /\d(?=_)/.exec(ownProps.match.path);
    const newAnswer = {
      resultId,
      answer: null
    };
    const dialogData = {
      title: "削除してもよろしいですか？",
      contentText: "（この操作は取り消せませんので注意してください。）",
      btnLabel: "OK",
      handleClick: () => {
        api
          .post(`free_opinion_${pathNum}_report/${id}`, newAnswer)
          .then(res => {
            dispatch(closeConfirmDialog());
            if ("errors" in res) {
              dispatch(setErrors(res.errors));
            }
            dispatch(setFreeOpinionReport(res));
            dispatch(showSnackbar("更新しました"));
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };
    dispatch(openConfirmDialog(dialogData));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(FreeOpinionReport);



// WEBPACK FOOTER //
// ./src/containers/ReportDetail/FreeOpinionReportContainer.js